export default __webpack_public_path__ + "static/media/caret-down-blue.c66caa6d.svg";